module.exports = __webpack_public_path__ + "media/images/category/feature/coj_f/hero_mob-eb59e5008c792e9398e0f751f7f467e3.jpg";